import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

const callCenterBreadcrumbs = generateBreadcrumbs({
  label: 'call_center.call_center',
  route: { name: 'call-center' },
});

export default {
  path: 'contacts/details/:contactId',
  name: 'contact-details',
  meta: {
    permissions: 'read-webphone',
    breadcrumbs: callCenterBreadcrumbs({
      label: 'call_center.contact_details.title',
      route: { name: 'contact-details' },
    }),
  },
  component: () => import('@/components/ContactDetails/Index.vue'),
};
